import clsx from "clsx";
import { Helpers } from "../helpers/Helpers";
import Box from "./Box";

export interface TableActionModel {
    text: string
    onClick?: () => void
    isDisabled?: boolean
    bg?: string
    subItems?: TableActionModel[]
}

interface Props {
    list: (TableActionModel | undefined)[]
    title: string
    faIcon: string
}

const TableActions = ({
    list,
    title,
    faIcon
}: Props) => {
    const randomId = Helpers.generateUUID();

    return (
        <div className='m-0'>
            <a
                id={"optionsContainerButton-" + randomId}
                className={clsx('btn btn-sm btn-flex fw-bold bg-gray-200 btn-color-gray-700 btn-active-color-primary btn-active-light-primary')}
                data-kt-menu-trigger='click'
                data-kt-menu-placement='bottom-end'
                data-kt-menu-static="true"
            >
                <i className={'fa ' + faIcon + ' fs-6 color-gray-700 me-1'} />
                {title}
            </a>

            <div className='menu menu-sub menu-sub-dropdown w-300px w-md-300px' data-kt-menu='true'>
                <div className='px-7 py-5'>
                    <Box flexDirection="row">
                        <Box justifyContent="center" flexGrow={1}>
                            <div className='fs-5 text-gray-900 fw-bolder'>{title}</div>
                        </Box>
                        <Box justifyContent="center">
                            <i style={{ fontSize: '18px' }} data-kt-menu-dismiss='true' className="actionIcon text-gray-900 fa fa-times" />
                        </Box>
                    </Box>
                </div>

                <div className='separator border-gray-200'></div>



                <div className='px-7 py-5'>
                    {
                        list.filter(x => x).map((item, index) => (
                            <div className="dropdown">
                                <button
                                    style={{ color: item?.bg ? 'white' : undefined, background: item?.bg ? item.bg : undefined }}
                                    disabled={item?.isDisabled}
                                    className={(index == 0 ? "" : 'mt-5') + (item?.bg ? ' ' : ' btn-primary ') + ' w-100 btn btn-sm btn-block'}
                                    onClick={() => {
                                        if (item && item.onClick) {
                                            item.onClick();
                                            document.getElementById("optionsContainerButton-" + randomId)?.click();
                                        }
                                    }}
                                    type="button"
                                    data-bs-toggle={item && item.subItems && item.subItems.length > 0 ? "dropdown" : undefined}
                                    aria-expanded={item && item.subItems && item.subItems.length > 0 ? "false" : undefined}
                                >
                                    {item?.text}
                                </button>

                                {
                                    item && item.subItems && item.subItems.length > 0 && (
                                        <ul className="w-100 dropdown-menu">
                                            {
                                                item.subItems.map((itemSub, indexSub) => (
                                                    <li>
                                                        {
                                                            indexSub > 0 && (
                                                                <div className='separator border-gray-200'></div>
                                                            )
                                                        }

                                                        <button
                                                            style={{ fontWeight: '600' }}
                                                            onClick={() => {
                                                                if (itemSub && itemSub.onClick) {
                                                                    itemSub.onClick();
                                                                    document.getElementById("optionsContainerButton-" + randomId)?.click();
                                                                }
                                                            }}
                                                            disabled={itemSub?.isDisabled}
                                                            className="text-center dropdown-item">
                                                            {itemSub.text}
                                                        </button>
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                    )
                                }
                            </div>
                        ))
                    }
                </div>
            </div>
        </div >
    )
}

TableActions.defaultProps = {
    title: 'İşlemler',
    faIcon: 'fa-cog'
}

export default TableActions;